import { AxiosClient } from "./AxiosClient";

export const sendCompanySearch = (company) => {
  try {
    return AxiosClient.post("cases/search", { company_name: company });
  } catch (e) {
    console.log(e);
  }
};

export const sendCompanySearchBackUp = (company) => {
  try {
    return AxiosClient.post("cases/backup_search", { company_name: company });
  } catch (e) {
    console.log(e);
  }
};

export const validateURL = (url) => {
  try {
    return AxiosClient.post("cases/validateURL", { url: url });
  } catch (e) {
    console.log(e);
  }
};

export const searchCompanyForCorrectUrl = (target) => {
  try {
    return AxiosClient.post("cases/searchCompanyForCorrectUrl", {
      target,
    });
  } catch (e) {
    console.log(e);
  }
};

export const saveCase = (caseName, domain) => {
  try {
    return AxiosClient.post("cases/saveCase", { caseName, domain });
  } catch (e) {
    console.log(e);
  }
};

export const activateCase = (target, activate) => {
  try {
    return AxiosClient.post("cases/activateCase", { target, activate });
  } catch (e) {
    console.log(e);
  }
};

export const deleteCase = (target) => {
  try {
    return AxiosClient.post("cases/deleteCase", { target });
  } catch (e) {
    console.log(e);
  }
};

export const getCases = () => {
  try {
    return AxiosClient.get("cases/getCases");
  } catch (e) {
    console.log(e);
  }
};
